import "./styles.scss";
import edit from "./edit";

import { __ } from "@wordpress/i18n";
import { InnerBlocks } from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import icons from "~buildable/utils/icons";

export const name = "buildable/testimonial-slider";

export const settings = {
  title: "Testimonial Slider",
  icon: icons.testimonial,
  category: "buildable-groups",
  supports: {
    align: ['full']
  },
  /** @var TestimonialSlider_Attributes object */
  attributes: TestimonialSlider_Attributes,
  description: __("Want to show visitors to your site a list of quotes or testimonials? Using the Testimonial Slider block makes this very easy with automated rotation of testimonials."),
  edit,
  save: () => <InnerBlocks.Content />
}

registerBlockType(name, settings);
